import { Component, Inject, Input, OnInit } from '@angular/core';
import { GroupedTickets } from '@ridango/core';

import momenttz from 'moment-timezone';
@Component({
    selector: 'ridango-grouped-tickets-header',
    templateUrl: './grouped-tickets-header.component.html',
    styleUrls: ['./grouped-tickets-header.component.css']
})
export class GroupedTicketsHeaderComponent implements OnInit {
    @Input() tickets: GroupedTickets;
    @Input() locale: string;
    @Input() currency: string;

    hasTripMessages = false;
    tripMessages: any[];

    dayNames = [
        'LOCAL_CALENDAR_SUNDAY_ddd',
        'LOCAL_CALENDAR_MONDAY_ddd',
        'LOCAL_CALENDAR_TUESDAY_ddd',
        'LOCAL_CALENDAR_WEDNESDAY_ddd',
        'LOCAL_CALENDAR_THURSDAY_ddd',
        'LOCAL_CALENDAR_FRIDAY_ddd',
        'LOCAL_CALENDAR_SATURDAY_ddd'
    ];

    constructor(@Inject('ENV') public env: any) {}

    ngOnInit() {
        const ticketWithMessage = this.tickets.tickets.find((t) => t.trip_messages && t.trip_messages.length > 0);
        this.tripMessages = ticketWithMessage && ticketWithMessage.trip_messages;
        this.hasTripMessages = !!(this.tripMessages && this.tripMessages.length);
    }

    getTime(t: GroupedTickets, type: string) {
        let hours = 0;
        let minutes = 0;
        if (type === 'D') {
            hours = Math.floor(t.origin_stop_time_min / 60);
            minutes = t.origin_stop_time_min - hours * 60;
        } else if (type === 'A') {
            hours = Math.floor(t.destination_stop_time_min / 60);
            minutes = t.destination_stop_time_min - hours * 60;
        } else {
            return '';
        }

        let sH = '';
        let sM = '';
        sH = '' + hours;
        sM = '' + minutes;
        if (hours < 10) {
            sH = '0' + hours;
        }
        if (minutes < 10) {
            sM = '0' + minutes;
        }

        return sH + ':' + sM;
    }
    formatDate(time) {
        return momenttz.tz(time, 'Europe/Tallinn').format(this.env.DATE_PICKER_DISPLAY_FORMAT);
    }
}
